















import { defineComponent } from '@vue/composition-api'
import { ORGANIZATION_JSONLD } from '@/assets/constants/common-jsonld'

export default defineComponent({
  setup () {
    return {
      ORGANIZATION_JSONLD,
    }
  },
})
